var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAnimate)?_c('Utility',{attrs:{"icon":"Open"},nativeOn:{"click":function($event){return _vm.animateModel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t(_vm.animationState))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }